/**
 * Number formatting and digit conversion utilities
 * Handles Persian/Arabic/English digit conversions
 */

const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";
const ENGLISH_DIGITS = "0123456789";

/**
 * Convert English digits to Persian digits
 * Example: "123" → "۱۲۳"
 * Example: "$123.45" → "$۱۲۳.۴۵"
 */
export function toPersianDigits(input: string | number): string {
  const str = String(input);
  
  return str
    .split("")
    .map((char) => {
      const englishIndex = ENGLISH_DIGITS.indexOf(char);
      if (englishIndex !== -1) {
        return PERSIAN_DIGITS[englishIndex];
      }
      return char;
    })
    .join("");
}

/**
 * Convert Persian digits to English digits
 * Example: "۱۲۳" → "123"
 */
export function toEnglishDigits(input: string): string {
  return input
    .split("")
    .map((char) => {
      const persianIndex = PERSIAN_DIGITS.indexOf(char);
      if (persianIndex !== -1) {
        return ENGLISH_DIGITS[persianIndex];
      }
      return char;
    })
    .join("");
}

/**
 * Check if current locale uses Persian digits
 */
export function usesPersianDigits(locale: string): boolean {
  return locale === "fa" || locale === "fa-IR" || locale.startsWith("fa-");
}

/**
 * Conditionally convert digits based on locale
 */
export function localizeDigits(value: string | number, locale: string): string {
  if (usesPersianDigits(locale)) {
    return toPersianDigits(value);
  }
  return String(value);
}
